import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

export default class extends Controller {
  static targets = ["statusFilter", "dateFromFilter", "dateToFilter"];

  connect() {
    const tableElement = $(this.element).find("#reservations-table");

    this.dataTable = tableElement.DataTable({
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50],
      order: [[4, "desc"]], // sort by Expires At by default
      dom:
        "<'row mb-3'<'col-sm-4'l><'col-sm-4'><'col-sm-4'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      language: { searchPlaceholder: "Search reservations...", search: "" }
    });

    // Custom filtering logic
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      if (settings.nTable !== tableElement[0]) return true;

      const selectedStatus = this.statusFilterTarget.value;
      const rowStatus = data[3].toLowerCase(); // Status column, badge text lowercased

      const dateFrom = this.dateFromFilterTarget.value;
      const dateTo = this.dateToFilterTarget.value;
      const expiresAt = this._parseDate(data[4]); // Expires At column

      // Status Filtering
      if (selectedStatus && !rowStatus.includes(selectedStatus)) {
        return false;
      }

      // Date Range Filtering
      if (dateFrom) {
        const fromDate = new Date(dateFrom);
        if (expiresAt < fromDate) return false;
      }

      if (dateTo) {
        const toDate = new Date(dateTo);
        if (expiresAt > toDate) return false;
      }

      return true;
    });

    // Listeners
    this.statusFilterTarget.addEventListener("change", () => this.refresh());
    this.dateFromFilterTarget.addEventListener("change", () => this.refresh());
    this.dateToFilterTarget.addEventListener("change", () => this.refresh());
  }

  refresh() {
    this.dataTable.draw();
  }

  clearFilters() {
    this.statusFilterTarget.value = "";
    this.dateFromFilterTarget.value = "";
    this.dateToFilterTarget.value = "";
    this.dataTable.search("");
    this.dataTable.draw();
  }

  // For parsing date strings like "23-Nov-2025 14:00"
  _parseDate(dateStr) {
    return new Date(Date.parse(dateStr.replace(/-/g, " ")));
  }
}
